export { default } from './MobileTabPanes';
